import React, { Component } from 'react';
import CheckboxListItem from '../ldapMappingCheckboxListItem';

export default class List extends Component {

    render() {
        
        if (this.props.items == undefined) {
            
            return null;
        }
        
        return (
            <div>
                {
                    this.props.items.map((item, index) => {

                        return <CheckboxListItem
                                    key={item.id}
                                    dataKey={item.id}
                                    checked={item.selected}
                                    imported={item.imported}
                                    name={item.name}
                                    group={item.group}
                                    selcted={item.selectd}
                                    toggle={this.props.toggle}
                                    translations={this.props.translations}
                                />
                    })
                }
            </div>
        );
    }
}
